import React, { useContext, useEffect, useState } from "react";
import { Input, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  changePassword,
  resetPasswordInfo,
} from "../../actionCreator/commonActionCreator";
import { msgEnum } from "../../config";
import { AuthContext } from "../../context/AuthContext";

const Info = ({ setActiveTab }) => {
  const userAccountInfo = useSelector(
    (state) => state?.CommonReducer?.accountInfo,
  );
  const formIntialValue = {
    username: { disabled: true, value: userAccountInfo?.login, status: null },
    curpass: { disabled: false, value: "", status: null },
    npass: { disabled: false, value: "", status: null },
    cpass: { disabled: false, value: "", status: null },
  };

  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const [form, setForm] = useState(formIntialValue);
  const [showPassword, setShowPassword] = useState(false);
  const [showNPassword, setShowNPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [errorObj, setError] = useState();

  const [successMsg, setSuccessMsg] = useState("");
  const updatePasswordInfo = useSelector(
    (state) => state?.CommonReducer?.updatePasswordInfo,
  );
  useEffect(() => {
    setForm(formIntialValue);
  }, [userAccountInfo]);

  useEffect(() => {
    if (Object.keys(updatePasswordInfo).length) {
      setSuccessMsg(msgEnum.PASSWORD_UPDATE_MSG);
      setForm(formIntialValue);
      setShowPassword(false);
      setShowCPassword(false);
      setShowNPassword(false);
      dispatch(resetPasswordInfo());
    }
  }, [updatePasswordInfo]);

  const updateSettings = () => {
    //console.log(form, "formform");
    let payload = userAccountInfo;
    payload.curpass = form.curpass.value;
    payload.npass = form.npass.value;
    payload.cpass = form.cpass.value;
    payload.username = form.username.value;
    let errObj = {};
    if (!payload?.username) {
      errObj = {
        ...errObj,
        username: "Please enter username.",
      };
    }
    if (!payload?.curpass) {
      errObj = {
        ...errObj,
        curpass: "Please enter current password.",
      };
    }
    if (!payload?.npass) {
      errObj = {
        ...errObj,
        npass: "Please enter new password.",
      };
    }
    if (!payload?.cpass) {
      errObj = {
        ...errObj,
        cpass: "Please enter confirm password.",
      };
    }
    if (payload?.npass && payload?.cpass && payload?.npass !== payload?.cpass) {
      errObj = {
        ...errObj,
        cpass: "The new password that you entered do not match!",
      };
    }
    setError(errObj);
    if (!Object.keys(errObj).length) {
      const formpayload = {
        currentPassword: payload?.curpass,
        newPassword: payload?.npass,
      };
      dispatch(changePassword(isAuthenticated, formpayload));
    }
  };

  const onInputChange = (ele) => {
    setForm({
      ...form,
      [ele.target.name]: { ...form[ele.target.name], value: ele.target.value },
    });
  };
  const handlePasswordText = (val, type) => {
    if (type === 1) {
      if (val === 1) {
        //password input type should be text
        setShowPassword(true);
      } else {
        //password input type should be password
        setShowPassword(false);
      }
    } else if (type === 2) {
      if (val === 1) {
        //password input type should be text
        setShowNPassword(true);
      } else {
        //password input type should be password
        setShowNPassword(false);
      }
    } else if (type === 3) {
      if (val === 1) {
        //password input type should be text
        setShowCPassword(true);
      } else {
        //password input type should be password
        setShowCPassword(false);
      }
    }
  };

  return (
    <>
      {/* <div  style={{marginLeft:25, width:300}}>
   <div className="card shadow mb-2">
        <div className="similarblk">
        <div className="similarinnerblk">
        <div className="s-company ml-3"><i className=" fs-25  las la-chalkboard-teacher"></i></div>
        <div className="similar-desc text-align-left">
        <div className="font-weight-bold fs-16">Instructions</div>
        <div className=" fs-12"> 
        <ul type="disc">
          <li> •	Minimum Length 6 characters</li>
          <li> •	Maximum Length: 32 characters</li>
          <li> •	Blank Spaces are not allowed</li>
        </ul>
        </div>
       </div>
       </div>
        </div>
        </div>
        </div> */}

      <div
        style={{ marginLeft: 25, marginBottom: 25 }}
        className="errorformcontainer mt-3"
      >
        <div
          style={{
            marginBottom: 20,
            textAlign: "center",
            verticalAlign: "center",
          }}
        >
          <span style={{ color: "#02AA02", fontSize: 18 }}>{successMsg}</span>
        </div>
        {/* <span>{successMsg}</span> */}

        <div id="input-style" className="form">
          <div className="formcol1">User Name</div>
          <div className="formcol2">
            <Input
              name="username"
              type="text"
              value={form?.username?.value}
              placeholder="User Name"
              onChange={onInputChange}
              readOnly
            />
            <div className="errorTxt">{errorObj?.username}</div>
          </div>
          <span>
            <i className="fa fa-user-times loginpwd"></i>
          </span>
        </div>

        <div className="form">
          <div className="formcol1">Current Password</div>
          <div className="formcol2 ">
            <Input
              name="curpass"
              className="input-s"
              type={showPassword ? "text" : "password"}
              value={form?.curpass?.value}
              placeholder="Password"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.curpass}</div>
          </div>
          <span className="icons i2">
            {showPassword ? (
              <i
                className="fa fa-eye loginpwd"
                onClick={() => handlePasswordText(0, 1)}
              ></i>
            ) : (
              <i
                className="fa fa-eye-slash loginpwd"
                onClick={() => handlePasswordText(1, 1)}
              ></i>
            )}
          </span>
          {/* <i className=" pr-1 fs-18 las la-pen"></i> */}
        </div>
        <div className="form">
          <div className="formcol1">
            <label>New Password</label>
          </div>
          <div className="formcol2">
            <Input
              className="input-s"
              type={showNPassword ? "text" : "password"}
              name="npass"
              value={form?.npass?.value}
              placeholder="New Password"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.npass}</div>
          </div>
          <span className="icons i2">
            {showNPassword ? (
              <i
                className="fa fa-eye loginpwd"
                onClick={() => handlePasswordText(0, 2)}
              ></i>
            ) : (
              <i
                className="fa fa-eye-slash loginpwd"
                onClick={() => handlePasswordText(1, 2)}
              ></i>
            )}
          </span>
        </div>
        <div className="form">
          <div className="formcol1">
            <label>Confirm Password</label>
          </div>
          <div className="formcol2">
            <Input
              className="input-s"
              type={showCPassword ? "text" : "password"}
              name="cpass"
              value={form?.cpass?.value}
              placeholder="Confirm Password"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.cpass}</div>
          </div>
          <span className="icons i2">
            {showCPassword ? (
              <i
                className="fa fa-eye loginpwd"
                onClick={() => handlePasswordText(0, 3)}
              ></i>
            ) : (
              <i
                className="fa fa-eye-slash loginpwd"
                onClick={() => handlePasswordText(1, 3)}
              ></i>
            )}
          </span>
        </div>
        <div className="mt-3 mb-3">
          <span className="mt-3 mr-3">
            {" "}
            <Button className="btn-info" type="primary" onClick="">
              Cancel
            </Button>
          </span>
          <span className="mt-3 mr-3">
            <Button
              className="btn-info"
              type="primary"
              onClick={updateSettings}
            >
              Save
            </Button>
          </span>
        </div>
      </div>
    </>
  );
};
export default Info;
